
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import "moment/locale/es";


const EventComponent = ({ event, setData, getViewMode }) => {
  const [enable, setEnable] = useState(true);
  const [viewMode, setViewMode] = useState(getViewMode());

  useEffect(() => {
    var dateStart = moment(event.start);
    var dateNow = moment(new Date());
    if (dateStart.diff(dateNow) < 0) {
      setEnable(false);
    }

  }, []);


  return (
    <div>
      {
        viewMode === 'month' ? <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <p style={{ color: enable ? '#FFFFFF' : '#6c757d' }}>
            {event.title} {moment(event.start).format("hh:mm")} - {moment(event.end).format("hh:mm a")} {" "}
            {event.nombres || event.nombre}{event.nombre_paciente != "" && event.nombre_paciente != undefined && event.nombre_paciente != null ? " - " + event.nombre_paciente : ""}
            {" - "}<b>{event.nombre_atencion}</b>
          </p>
        </div>
          : null
      }
      {
        viewMode === 'week' ? <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <p style={{ color: enable ? '#FFFFFF' : '#6c757d' }}>
            {event.nombres || event.nombre}
            <br />
            {event.nombre_paciente != "" && event.nombre_paciente != undefined && event.nombre_paciente != null ? event.nombre_paciente : ""}
            {" - " + event.nombre_atencion}
          </p>
        </div>
          : null
      }
      {
        viewMode === 'day' ? <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <p style={{ color: enable ? '#FFFFFF' : '#6c757d' }}>
            {event.title} {moment(event.start).format("hh:mm")} - {moment(event.end).format("hh:mm a")} {" "}
            {event.nombres || event.nombre}{event.nombre_paciente != "" && event.nombre_paciente != undefined && event.nombre_paciente != null ? " - " + event.nombre_paciente : ""}
            {" - " + event.nombre_atencion}
          </p>
        </div>
          : null
      }
      {
        viewMode === 'agenda' ? <a className='agenda-medical' style={{textDecoration: 'none'}} href="#">
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }} onClick={(e) => {
          setData(event);
        }}>
          <p style={{ color: enable ? '#FFFFFF' : '#6c757d' }}>
            {event.title} {moment(event.start).format("hh:mm")} - {moment(event.end).format("hh:mm a")} {" "}
            {event.nombres || event.nombre}{event.nombre_paciente != "" && event.nombre_paciente != undefined && event.nombre_paciente != null ? " - " + event.nombre_paciente : ""}
            {event.nombre_atencion}
          </p>
        </div></a>
          : null
      }
    </div>




  )
};

export default EventComponent;